// @flow

export const OriginAppNames = Object.freeze({
    KING5: 'king5',
    WINAMAXTV: 'winamaxtv',
    GNG: 'gng'
});

export type OriginApps = $Values<typeof OriginAppNames>;
